import tiersTypes from './tiers.types';
import axios from 'axios';
import Socket from 'socket.io-client';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `${process.env.VUE_APP_API_LIVE_URI}/tiers`;
} else {
  url = `${process.env.VUE_APP_API_TEST_URI}/tiers`;
}

const io = Socket(url);
export default {
  fetchTiers({ commit }) {
    const ls = JSON.parse(localStorage.getItem('user'));
    commit(tiersTypes.FETCH_TIERS_REQUEST);
    io.emit('fetch tiers', { manager_email: ls.profile.email });
    io.on('tiers', function(data) {
      commit(tiersTypes.FETCH_TIERS_SUCCESS, {
        data: { tiers: data }
      });
    });
    io.on('fetch action error', err => {
      return commit(tiersTypes.FETCH_TIERS_FAILED, {
        error: err.message
      });
    });
  },

  addTier({ commit }, data) {
    const ls = JSON.parse(localStorage.getItem('user'));
    commit(tiersTypes.ADD_TIER_REQUEST);
    axios
      .post(`${url}/add?email=${ls.profile.email}`, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ls.accessToken}`
        }
      })
      .then(() => {
        commit(tiersTypes.ADD_TIER_SUCCESS);
        io.emit('fetch tiers', { manager_email: ls.profile.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(tiersTypes.ADD_TIER_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(tiersTypes.ADD_TIER_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(tiersTypes.ADD_TIER_FAILED, { error });
      });
  },

  updateTier({ commit }, tier) {
    commit(tiersTypes.UPDATE_TIER_REQUEST);
    const ls = JSON.parse(localStorage.getItem('user'));
    axios
      .post(`${url}/update?email=${ls.profile.email}`, tier, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ls.accessToken}`
        }
      })
      .then(() => {
        commit(tiersTypes.UPDATE_TIER_SUCCESS);
        io.emit('fetch tiers', { manager_email: ls.profile.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(tiersTypes.UPDATE_TIER_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(tiersTypes.UPDATE_TIER_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(tiersTypes.UPDATE_TIER_FAILED, { error });
      });
  },

  deleteTier({ commit }, tier) {
    commit(tiersTypes.DELETE_TIER_REQUEST);
    const ls = JSON.parse(localStorage.getItem('user'));
    axios
      .get(`${url}/delete?email=${ls.profile.email}&tier_id=${tier._id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ls.accessToken}`
        }
      })
      .then(res => {
        commit(tiersTypes.DELETE_TIER_SUCCESS);
        io.emit('fetch tiers', { manager_email: ls.profile.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(tiersTypes.FETCH_TIERS_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(tiersTypes.DELETE_TIER_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(tiersTypes.DELETE_TIER_FAILED, { error });
      });
  }
};
